import { createContext, useState } from "react";

interface GenerateInvoicePdfActionContextType {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  invoiceId: string | number | null;
  setInvoiceId: (id: string | number | null) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  sendToCustomer: boolean;
  setSendToCustomer: (send: boolean) => void;
}

export const GenerateInvoicePdfActionContext = createContext<GenerateInvoicePdfActionContextType>({
  showModal: false,
  setShowModal: () => {},
  invoiceId: null,
  setInvoiceId: () => {},
  loading: false,
  setLoading: () => {},
  sendToCustomer: true,
  setSendToCustomer: () => {},
});

export const GenerateInvoicePdfActionProvider: React.FC<{ children: any }> = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [invoiceId, setInvoiceId] = useState<string | number | null>(null);
  const [loading, setLoading] = useState(false);
  const [sendToCustomer, setSendToCustomer] = useState(true);

  return (
    <GenerateInvoicePdfActionContext.Provider value={{ showModal, setShowModal, invoiceId, setInvoiceId, loading, setLoading, sendToCustomer, setSendToCustomer }}>
      {children}
    </GenerateInvoicePdfActionContext.Provider>
  );
};
